var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography, styled } from '@mui/material';
import { RecordContextProvider } from 'react-admin';
var NodeTitle = function (props) {
    var data = props.data, nodeActions = props.nodeActions, rest = __rest(props, ["data", "nodeActions"]);
    return (_jsx(RecordContextProvider, { value: data.record, children: _jsxs(Root, __assign({}, rest, { children: [_jsx(Typography, { variant: "body1", children: typeof data.title === 'function'
                        ? data.title(data)
                        : data.title }), _jsx("div", { className: NodeTitleClasses.menuButton, children: nodeActions })] })) }));
};
export default NodeTitle;
var PREFIX = 'RaNodeTitle';
export var NodeTitleClasses = {
    menuButton: "".concat(PREFIX, "-menuButton"),
};
var Root = styled('div', {
    name: PREFIX,
    overridesResolver: function (props, styles) { return styles.root; },
})(function (_a) {
    var _b, _c;
    var theme = _a.theme;
    return (_b = {
            position: 'relative',
            display: 'flex',
            width: '100%',
            height: '100%',
            alignItems: 'center',
            overflowY: 'hidden'
        },
        _b["& .MuiTypography-root"] = {
            flex: '1 1 auto',
        },
        _b['&:hover'] = (_c = {},
            _c["& .".concat(NodeTitleClasses.menuButton, " button")] = {
                opacity: 1,
            },
            _c),
        _b["& .".concat(NodeTitleClasses.menuButton, " button")] = {
            flex: '0 0 auto',
            display: 'flex',
            alignItems: 'center',
            height: '100%',
            background: 'transparent',
            border: 'none',
            opacity: 0,
            outline: 'none',
            marginLeft: theme.spacing(1),
            '&:focus': {
                opacity: 1,
            },
        },
        _b);
});
